import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  department: Yup.string().required('Campo obrigatório'),
});
